import { Modal, Result } from 'antd';
import React from 'react';

const removePaymentStatusParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('status');
  window.location.href = url;
};

export const SuccessDialog = React.memo(
  ({ show, setShowSuccessDialog, messages }) => {
    return (
      <Modal
        visible={show}
        transitionName=""
        onOk={() => {
          setShowSuccessDialog(false);
          removePaymentStatusParam();
        }}
        closable={false}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Result
          status="success"
          title={messages.payment_success_title}
          subTitle={messages.payment_success_subtitle}
        />
      </Modal>
    );
  },
  (prevProps, nextProps) => prevProps.show === nextProps.show
);

export const ErrorDialog = React.memo(
  ({ show, setShowErrorDialog, messages }) => {
    return (
      <Modal
        visible={show}
        transitionName=""
        onOk={() => {
          setShowErrorDialog(false);
          removePaymentStatusParam();
        }}
        closable={false}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Result
          status="error"
          title={messages.payment_error_title}
          subTitle={messages.payment_error_subtitle}
        />
      </Modal>
    );
  },
  (prevProps, nextProps) => prevProps.show === nextProps.show
);

export const getMissingFieldsOnUser = (
  user,
  inCompleteGrowerFieldMessages,
  fieldsToCheck
) => {
  const missingFields = [];
  if (user) {
    fieldsToCheck.forEach((requiredField) => {
      if (!user[requiredField])
        missingFields.push(inCompleteGrowerFieldMessages[requiredField]);
    });
  }

  return missingFields;
};
